import React, {Component} from 'react';
import {client} from '../../Client';
import { Button, Form, Message, Input } from 'semantic-ui-react'
import ColorPicker from '../ColorPicker';
import {convertNullToEmptyString} from '../../Helpers'
import ErrorMessage from '../ErrorMessage'
import {Redirect} from 'react-router-dom';
import 'moment/locale/it.js';
import 'rc-datepicker/lib/style.css';
import ImgProfiloUpload from './ImgProfiloUpload';

class ProfiloUtenteForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: this.props.match.params.id, // Se undefined siamo in insert, altr in update
      inUpdate: this.props.match.params.id !== undefined,
      fields: this.getEmptyFields(),
      fieldErrors: {},
      fieldErrorsText: [],
      inError: false,
      _loading: false,
      errorTitle: '',
      saveSuccess: false,
      cancelSuccess: false,
      error: null,
      itemSaved: null,
  };

  this.handleSubmit = this.handleSubmit.bind(this)
  this.handleCancel = this.handleCancel.bind(this)
  this.handleDeleteImage = this.handleDeleteImage.bind(this)
  this.formIsValid = this.formIsValid.bind(this)
  this.onInputChange = this.onInputChange.bind(this)
  this.onInputChangeUppercase = this.onInputChangeUppercase.bind(this)
  this.isLoadingInProgress = this.isLoadingInProgress.bind(this)
  this.onUpload = this.onUpload.bind(this)
  }

  onUpload(documento) {
    let formData = this.state.fields;
    formData["imgProfilo"] = documento.fileName;
    this.setState({fields: formData });
  }

  isLoadingInProgress(){
    return this.state._loading;
  }

  componentDidMount() {
    if (this.state.inUpdate)
    {
        this.setState({ _loading: true });
        client.loadUtente(this.state.id).then(
            (response) => {
                if (response.ok){
                    response.json().then((utente) => {
                        
                        let fields = convertNullToEmptyString(utente);
                        this.setState({ _loading: false, fields: fields,  fieldErrors: {},
                            fieldErrorsText: [], inError: false, error: null, itemSaved: utente});
                        this.forceUpdate();
                    })
                }
                else if (response.status === 401)
                {
                    this.props.history.push("/login")
                }
                else
                {
                    response.json().then((errore) => {
                        let fieldErrorsText = []
                        let fieldErrors = {}
                        this.setState({
                            _loading: false,
                            fieldErrors: fieldErrors,
                            fieldErrorsText: fieldErrorsText,
                            errorTitle: '',
                            error: {title: errore.title, msg: errore.msg},
                            inError: true
                        });
                    });

                }
        }).catch((error) => {

            let fieldErrorsText = []
            let fieldErrors = {}
            this.setState({
                _loading: false,
                fieldErrors: fieldErrors,
                fieldErrorsText: fieldErrorsText,
                errorTitle: '',
                error: {title: "Errore di rete imprevisto", msg: error.message},
                inError: true
            });

        });
    }
    else {
      // Se non è un update, ricarica la pagina iniziale
      this.props.history.push("/login");
    }
  }

  getEmptyFields() {
    return {
        'bkgColor1': '#005BAB',
        'bkgColor2': '#569EDD',
        'imgProfilo': 'generic-user-profile.jpg',
    }
  }

  formIsValid(formData) {
    // Validazione dati
    let fieldErrorsText = []
    let fieldErrors = {}

    /* Aggiungere eventuali controlli, ad es:

    if (formData.dataChiusura === "Invalid date"){
      fieldErrors["dataChiusura"] = true;
      fieldErrorsText.push("La data di chiusura non è nel formato corretto (gg/mm/aaaa)");
    }
    */

    if (Object.keys(fieldErrors).length > 0)
    {
        this.setState({
            fieldErrors: fieldErrors,
            fieldErrorsText: fieldErrorsText,
            errorTitle:"La form contiene errori",
            inError: true
        })
        return false;
    }
    return true;
}

handleCancel(e) {

    e.preventDefault();
    this.setState({cancelSuccess: true})
}

handleDeleteImage(e) {
    e.preventDefault();

    let formData = this.state.fields;
    formData["imgProfilo"] = "";
    this.setState({fields: formData });
}

handleSubmit(e) {
    e.preventDefault();
    let formData = this.state.fields;
    formData["bkgColor1"] = this.state.fields["bkgColor1"];
    formData["bkgColor2"] = this.state.fields["bkgColor2"];

    // Validazione form
    if (!this.formIsValid(formData)){
        return;
    }

    // Salvataggio sul server
    delete formData["stato-search"];
    this.setState({_loading: true});
    client.updateUtente(
        formData,
        this.state.fields.idUtente
    ).then((response) => {
        if (response.ok){
            response.json().then((data) => {
                let fields = this.state.fields;
                fields["idUtente"] = data.idUtente;
                this.setState({
                    _loading: false,
                    inError: false,
                    fieldErrors: {},
                    fieldErrorsText: [],
                    saveSuccess: true,
                    successTitle: "Salvataggio utente",
                    successText: "I deti del profilo Utente sono stati salvati correttamente",
                    fields: fields,
                    itemSaved: data,
                });
            })
        }
        else if (response.status === 401)
        {
            this.props.history.push("/login")
        }
        else
        {
            response.json().then((error) => {
                let fieldErrorsText = []
                let fieldErrors = {}

                if (error.errors !== undefined){
                    Object.keys(error.errors).map((item) => {
                        fieldErrors[item] = true;
                        fieldErrorsText = fieldErrorsText.concat(item + ":" +error.errors[item]);
                        return 0;
                    });
                }
                else {
                    fieldErrorsText = [error.message]
                }
                this.setState({
                    _loading: false,
                    fieldErrors: fieldErrors,
                    fieldErrorsText: fieldErrorsText,
                    errorTitle:error.title,
                    inError: true
                });
            })
        }
    }).catch((error) => {
        this.setState({
            _loading: false,
            fieldErrors: {},
            fieldErrorsText: [error.message],
            errorTitle: "Errore di rete imprevisto",
            inError: true
        });
    });
  }

  onInputChange(a1, {name, value}){

    if (name !== undefined)
    {
        const fields = this.state.fields;
        fields[name] = value;
        this.setState({ fields });
    }
  }

  onInputChangeUppercase(a1, {name, value}){
    if (name !== undefined)
    {
        const fields = this.state.fields;

        fields[name] = value.toUpperCase();

        this.setState({ fields });
    }
  }


  render() {

    if (this.state.error != null)
    {
        return (<ErrorMessage title={this.state.error.title} msg={this.state.error.msg} />)
    }

    let formInError = this.state.fieldErrorsText.length > 0;

    if (this.state.saveSuccess ){

        return <Redirect to={ {
            pathname: '/logout'
        }}/>
    }
    if (this.state.cancelSuccess){

        return <Redirect to={ {
            pathname: '/app/attivita'
        }}/>
    }

    let titleMsg = this.state.inUpdate ?
            <h3 className="ui block attached top header"><i className="edit icon"></i> Modifica Profilo Utente</h3>
            :
            <h3 className="ui block attached top header"><i className="add square icon"></i> Nuovo Utente</h3>

            let imgProfilo = "generic-user-profile.jpg";
            if (this.state.fields.imgProfilo){
              imgProfilo = this.state.fields.imgProfilo;
            }
            let btnCancella = null;
            if (this.state.fields.imgProfilo){
              btnCancella = (<a onClick={this.handleDeleteImage} style={{margin: "20px"}} className="ui right floated  red  button"><i className="delete icon"/>Cancella</a>);
            }
        return (
            <div>
            <Form onSubmit={this.handleSubmit} error={formInError} loading={this.state._loading} success={this.state.saveSuccess}>

                {titleMsg}
                <div className="ui attached segment">
                  <Form.Group widths="6">
                      <Form.Field width={6} label="Colore di Sfondo 1 (Barra in alto)" required={true} control={ColorPicker} name="bkgColor1" value={this.state.fields.bkgColor1} onChange={this.onInputChange} />
                  </Form.Group>
                  <Form.Group widths="6">
                      <Form.Field width={6} label="Colore di Sfondo 2 (Barra laterale)" required={true} control={ColorPicker} name="bkgColor2" value={this.state.fields.bkgColor2} onChange={this.onInputChange} />
                  </Form.Group>
                </div>
                <h3 className="ui block attached header">Immagine del Profilo</h3>
                <div className="ui attached segment">
                
                <Form.Group widths="12">
                  <Form.Field width={3} label="Immagine attuale" required={false} control={Input} name='imgProfilo' autoComplete="nope" readOnly="true"  placeholder='Nome immagine' maxLength="255"  value={this.state.fields.imgProfilo}  onChange={this.onInputChange}/>
                    <img width={"100"} alt="Immagine del Profilo" style={{margin: "5px"}} src={client.getApiBaseUrl()+"/images/"+imgProfilo}></img>
                    {btnCancella}
                </Form.Group>
                <ImgProfiloUpload
                onUpload={this.onUpload}
               />
                </div>

                <Message
                    error
                    header={this.state.errorTitle}
                    list={this.state.fieldErrorsText}
                />
                <Message
                    success
                    header={this.state.successTitle}
                    content={this.state.successText}
                    icon={"smile"}
                />

                <p></p>
                <div className="ui grid">
                    <div className="right aligned eight wide column">
                        <a onClick={this.handleCancel} className="ui right floated  secondary  button"><i className="undo icon"/>Annulla</a>
                    </div>
                    <div className="left aligned eight wide column">
                        <Button primary type='submit' loading={this.isLoadingInProgress()}><i className="save icon"/> Salva</Button>
                    </div>
                </div>



              

            </Form>
            </div>
        )
  }
}

export default ProfiloUtenteForm;




/** WEBPACK FOOTER **
 ** ./src/components/utenti/ProfiloUtenteForm.js
 **/